<template>
  <div class="modal-card">

        <b-loading :is-full-page=true v-model="isLoadingFullPage" ></b-loading>

        <!-- <header class="modal-card-head">
 


        </header> -->
        <section class="modal-card-body">
 
         <div class="container">
                <nav class="level is-mobile">
                                        <div class="level-left">
                                            <div class="level-item">
                                                   <b-button icon-left="reload" @click="reloadBlMor" >Reload Data Blood Morphology</b-button>
                                            </div>	
                                            <div class="level-item">
                                                    <b-input placeholder="Keratocyte or Anemia "
                                                            type="search"
                                                            icon="magnify"
                                                            v-model="filterWord"
                                                            v-if="dataBlMorLoaded" >
                                                    </b-input>	
                                            </div>	
                                        </div>
                                        <div class="level-right">
                                             <div class="level-item">
                                                    <b-button 
                                                          icon-left="plus" 
                                                          type="is-success"
                                                          @click="addNewBlMor" 
                                                          v-if="dataBlMorLoaded" >
                                                          Add New
                                                    </b-button>
                                            </div>	

                                            <div class="level-item">
                                                    <b-button 
                                                          icon-left="order-alphabetical-ascending" 
                                                          type="is-primary is-light"
                                                          @click="orderUpdate" 
                                                          v-if="dataBlMorLoaded" >
                                                          Order Update
                                                    </b-button>
                                            </div>	



                                        </div>
                </nav>



  <!-- paginated
                                pagination-size="is-medium"
                                pagination-position="bottom"
                                :current-page.sync="currentPage"
                                :per-page="perPage" -->



                <b-table        v-if="dataBlMorLoaded"
                                :data="filterData"
                                :bordered=false
                                :striped=false
                                narrowed
                                :hoverable=false
                                :focusable=false

                              

                                draggable
                                @dragstart="dragstartCUS1"
                                @drop="dropCUS1"
                                @dragover="dragoverCUS1"
                                @dragleave="dragleaveCUS1"

                                mobile-cards>


                            <b-table-column  label="No."  width="10%" v-slot="props">
                                {{ dataBlMor.indexOf(props.row) + 1 }}
                            </b-table-column>      
                            <b-table-column   label="Name"  v-slot="props"  >
                               <text-highlight :queries="queries">  {{props.row.name}} </text-highlight>
                            </b-table-column>

                            <b-table-column   label="Status"  v-slot="props"  >
                                <b-icon size="is-medium"
                                        :type="props.row.enable  ? 'is-success' : 'is-danger'"
                                        :icon="props.row.enable  ? 'check-circle' : 'stop-circle'">
                                </b-icon>

                              {{  props.row.enable  ? 'ใช้งาน' : 'ยกเลิก'}}
                            </b-table-column>

                            <b-table-column   label="#"  v-slot="props"  >
                                <b-button icon-left="pencil" type="is-warning"  @click="editBlMor(props.row)">Edit</b-button>
                            </b-table-column>


                     

                      

                        </b-table>




         </div>
                
                    






 

        </section>
        <footer class="modal-card-foot"  style="justify-content: space-between;">
            <b-button type="is-danger" @click="close">Close</b-button>
        </footer>


        
        <AddEditBlMor
            v-if="isAddEditBlMorShowing"
            :dataBlmorToEdit = "dataBlmorToEdit"
            :mode = "blMorMode"
            @close="closeAddEditBlMor"
            @closeWithDataChange = "closeAddEditBlMor_WithChange"
        />




    </div>
</template>


<script>
import axios from "axios";    /* eslint-disable */
import {  getBaseURLforBackEnd , getConfigAxios , genUUID }  from '@/utils.js'
import { mapState } from "vuex";
import AddEditBlMor from '../BloodMorphology/AddEditBlMor.vue'


export default {
    name : "BloodMorphologyMgr",
    created() {
        const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
            this.close()

            next(false)
        })

        this.$once('hook:destroyed', () => {
            unregisterRouterGuard()
        })
    },
    components:{
        AddEditBlMor ,
    },
    computed:{
            ...mapState({
                access_token : state => state.master_data.access_token,
            }) ,

            filterData(){

                // return this.dataBlMor 





                return this.dataBlMor.filter(dat=>{
                     if ( dat.name.toUpperCase().indexOf(this.filterWord.toUpperCase()) > -1        ){
                        return  dat
                    }
                })
            },
            queries(){
                return this.filterWord.split(" ");
            },
            // dataBlMorLoadedFilter(){
            //     // return this.dataBlMorLoaded

                
            //     const tmp = this.dataBlMor.filter((dat)=>{
            //         // console.log(listOfUser.id_auth_group)
            //         return dat.name.toUpperCase().indexOf(this.filterWord.toUpperCase()) > -1
            //     })

            //     return tmp
            // }
 

    },
    methods:{
 

        orderUpdate(){

            this.isLoadingFullPage = true



             const datTo = this.dataBlMor.map(dat=>{
                return {
                    "id" : dat.id ,
                    "order_" : dat.order_
                }
             })



            //  console.log(JSON.stringify(datTo))

              axios.defaults.headers.common['Authorization'] =  `Bearer ${this.access_token}`
              axios.post(`${getBaseURLforBackEnd()}/api/update_blmor_order`, datTo, getConfigAxios())
                    .then((res)=>{
                       this.isLoadingFullPage = false  
                       this.$buefy.toast.open({
                            duration: 1200,
                            message: `${res.data.msg}`,
                            type: 'is-primary'
                        })
                    })
                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                        this.isLoadingFullPage = false
                    })






        } ,




        swapArrayElementsCUS1 (arr, indexA, indexB) {
            var temp = arr[indexA];
            arr.splice(indexA,1)
            arr.splice(indexB,0,temp)
        },
        dragstartCUS1 (payload) {
            this.draggingRow = payload.row
            this.draggingRowIndex = payload.index
            payload.event.dataTransfer.effectAllowed = 'copy'
        },
        dragoverCUS1(payload) {
            payload.event.dataTransfer.dropEffect = 'copy'
            payload.event.target.closest('tr').classList.add('is-selected')
            payload.event.preventDefault()
        },
        dragleaveCUS1(payload) {
            payload.event.target.closest('tr').classList.remove('is-selected')
            payload.event.preventDefault()
        },
        dropCUS1(payload) {
            payload.event.target.closest('tr').classList.remove('is-selected')
            const droppedOnRowIndex = payload.index
            this.$buefy.toast.open({
                message: `Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`,
                duration:500
            })

            this.swapArrayElementsCUS1(this.dataBlMor , this.draggingRowIndex ,droppedOnRowIndex )
            this.dataBlMor[droppedOnRowIndex]['uuid'] = genUUID(10)
            this.dataBlMor[this.draggingRowIndex]['uuid'] = genUUID(10)
            this.makeOrder()
        },
        makeOrder(){
            this.dataBlMor.forEach((item, index) => {
                item['order_'] = index;
            });
        },





        close(){
            this.$emit('close')
        },

        closeAddEditBlMor_WithChange(){
            this.isAddEditBlMorShowing = false
            this.reloadBlMor()
        }, 
        closeAddEditBlMor(){
            this.isAddEditBlMorShowing = false
        },
        editBlMor(dat){
           this.blMorMode = 'U' 
           this.dataBlmorToEdit =  JSON.parse(JSON.stringify(dat))
           this.isAddEditBlMorShowing = true
        },
        addNewBlMor(){
            //Object.assign( {} ,DATAPATHOGEN_MODEL)
           this.blMorMode = 'I' 
           this.dataBlmorToEdit =  {"id": -1 ,"name": "","enable": true}
           this.isAddEditBlMorShowing = true
        },
        reloadBlMor(){
                this.isLoadingFullPage = true
                const datTo = {
                       "admin"  : true
                }
                axios.defaults.headers.common['Authorization'] =  `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/list_of_blmor`, datTo, getConfigAxios())
                    .then((res)=>{
                        this.dataBlMor = res.data
                        this.isLoadingFullPage = false
                        this.dataBlMorLoaded = true
                    })
                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                        this.isLoadingFullPage = false
                    })
        }
    },
    data(){
        return {
            isLoadingFullPage : false,

            dataBlMor : [],
            dataBlMorLoaded : false,

            filterWord : "",


            currentPage : 1,
            perPage : 15,

            isAddEditBlMorShowing : false,
            dataBlmorToEdit : {},
            blMorMode : 'I',



            draggingRow: null,
            draggingRowIndex: null ,

        }
    }
}
</script>
